var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaWindows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa-windows",
    clipPath: "url(#clip0_72_70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.648438 9.84971L18.9182 7.33214V24.985H0.648438V9.84971ZM0.648438 42.1502L18.9182 44.6678V27.2339H0.648438V42.1502ZM20.9283 44.9365L45.2283 48.2899V27.2339H20.9283V44.9365ZM20.9283 7.06346V24.985H45.2283V3.71002L20.9283 7.06346Z",
    fill: "#2F4C99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.5799,
    height: 50.9485,
    fill: "white",
    transform: "translate(0.648438 0.525757)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaWindows);
export default __webpack_public_path__ + "static/media/fa-windows.5e397bd9218b8b935972ee8e9a667ca8.svg";
export { ForwardRef as ReactComponent };